import axios from 'axios';
import mbpLogger from 'mbp-logger';
import jwtDecode from 'jwt-decode';
import Cookies from 'universal-cookie';
import memberClient from 'member-api';
function _typeof$2(o) {
  "@babel/helpers - typeof";

  return _typeof$2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof$2(o);
}
function _regeneratorRuntime() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */_regeneratorRuntime = function _regeneratorRuntime() {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function define(t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == _typeof$2(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function value(t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(_typeof$2(e) + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function stop() {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function complete(t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function finish(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    "catch": function _catch(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
var currentJWT = '';

// Get the value of environment variable with given variableName
var getEnv = function getEnv(variableName) {
  var windowHostname = typeof window !== 'undefined' && window.location && window.location.hostname;

  // Client/SSR: Default from local "production" vars
  var value = process.env[variableName];

  // Client: Pull from config-map generate env.js
  if (windowHostname && window.mbp && window.mbp.env) {
    value = window.mbp.env[variableName];
    if (!value && variableName === 'APP_WC_HOST') {
      value = window.location.hostname;
    }
  }

  // SSR: Pull from SSR specific "production" vars
  if (!windowHostname) {
    value = process.env["".concat(variableName, "_SSR")];
  }
  return value || process.env[variableName];
};
var isGuestToken = function isGuestToken(decodedJWT) {
  if (decodedJWT) {
    var f = decodedJWT['https://800-flowers.net'];
    if (f && f.type) {
      return f.type === 'guest';
    }
  }
  return false;
};
var isExpired = function isExpired(decodedJWT) {
  if (!decodedJWT.exp) {
    return false; // token without .exp never expires
  }
  var expirationUTCInMilliseconds = decodedJWT.exp * 1000;
  var timeNow = new Date();
  var UTCNowInMilliseconds = timeNow.getTime();
  return expirationUTCInMilliseconds < UTCNowInMilliseconds;
};
var testJWT = function testJWT(jwt) {
  if (!jwt) {
    return {
      isValid: false
    };
  }
  try {
    var decodedJWT = jwtDecode(jwt);
    return {
      isValid: true,
      isGuest: isGuestToken(decodedJWT),
      isExpired: isExpired(decodedJWT)
    };
  } catch (error) {
    return {
      isValid: false
    };
  }
};

// Return a promise which returns the current JWT token.
// If there is no current JWT, it will get a new guest JWT.
// If current token is an expired guest token,  it will get a new guest JWT.
// If current token is not a guest token (e.g. a user token set with setJWT),
// it is returned without any expiration checking.
function getJWT() {
  return _getJWT.apply(this, arguments);
}

// Set the current JWT.  Use this, e.g., to store a user JWT from login.
function _getJWT() {
  _getJWT = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var t;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          t = testJWT(currentJWT);
          if (!t.isValid || t.isGuest && t.isExpired) ;
          return _context.abrupt("return", currentJWT);
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _getJWT.apply(this, arguments);
}
function setJWT(token) {
  currentJWT = token;
}

/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

var mbpUtil = {
  getEnv: getEnv,
  getJWT: getJWT,
  setJWT: setJWT,
  testJWT: testJWT
};
var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}
var uaParser$1 = {
  exports: {}
};
(function (module, exports) {
  /////////////////////////////////////////////////////////////////////////////////
  /* UAParser.js v1.0.38
     Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
     MIT License */ /*
                    Detect Browser, Engine, OS, CPU, and Device type/model from User-Agent data.
                    Supports browser & node.js environment. 
                    Demo   : https://faisalman.github.io/ua-parser-js
                    Source : https://github.com/faisalman/ua-parser-js */
  /////////////////////////////////////////////////////////////////////////////////

  (function (window, undefined$1) {
    //////////////
    // Constants
    /////////////

    var LIBVERSION = '1.0.38',
      EMPTY = '',
      UNKNOWN = '?',
      FUNC_TYPE = 'function',
      UNDEF_TYPE = 'undefined',
      OBJ_TYPE = 'object',
      STR_TYPE = 'string',
      MAJOR = 'major',
      MODEL = 'model',
      NAME = 'name',
      TYPE = 'type',
      VENDOR = 'vendor',
      VERSION = 'version',
      ARCHITECTURE = 'architecture',
      CONSOLE = 'console',
      MOBILE = 'mobile',
      TABLET = 'tablet',
      SMARTTV = 'smarttv',
      WEARABLE = 'wearable',
      EMBEDDED = 'embedded',
      UA_MAX_LENGTH = 500;
    var AMAZON = 'Amazon',
      APPLE = 'Apple',
      ASUS = 'ASUS',
      BLACKBERRY = 'BlackBerry',
      BROWSER = 'Browser',
      CHROME = 'Chrome',
      EDGE = 'Edge',
      FIREFOX = 'Firefox',
      GOOGLE = 'Google',
      HUAWEI = 'Huawei',
      LG = 'LG',
      MICROSOFT = 'Microsoft',
      MOTOROLA = 'Motorola',
      OPERA = 'Opera',
      SAMSUNG = 'Samsung',
      SHARP = 'Sharp',
      SONY = 'Sony',
      XIAOMI = 'Xiaomi',
      ZEBRA = 'Zebra',
      FACEBOOK = 'Facebook',
      CHROMIUM_OS = 'Chromium OS',
      MAC_OS = 'Mac OS';

    ///////////
    // Helper
    //////////

    var extend = function extend(regexes, extensions) {
        var mergedRegexes = {};
        for (var i in regexes) {
          if (extensions[i] && extensions[i].length % 2 === 0) {
            mergedRegexes[i] = extensions[i].concat(regexes[i]);
          } else {
            mergedRegexes[i] = regexes[i];
          }
        }
        return mergedRegexes;
      },
      enumerize = function enumerize(arr) {
        var enums = {};
        for (var i = 0; i < arr.length; i++) {
          enums[arr[i].toUpperCase()] = arr[i];
        }
        return enums;
      },
      has = function has(str1, str2) {
        return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
      },
      lowerize = function lowerize(str) {
        return str.toLowerCase();
      },
      majorize = function majorize(version) {
        return typeof version === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split('.')[0] : undefined$1;
      },
      trim = function trim(str, len) {
        if (typeof str === STR_TYPE) {
          str = str.replace(/^\s\s*/, EMPTY);
          return typeof len === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
        }
      };

    ///////////////
    // Map helper
    //////////////

    var rgxMapper = function rgxMapper(ua, arrays) {
        var i = 0,
          j,
          k,
          p,
          q,
          matches,
          match;

        // loop through all regexes maps
        while (i < arrays.length && !matches) {
          var regex = arrays[i],
            // even sequence (0,2,4,..)
            props = arrays[i + 1]; // odd sequence (1,3,5,..)
          j = k = 0;

          // try matching uastring with regexes
          while (j < regex.length && !matches) {
            if (!regex[j]) {
              break;
            }
            matches = regex[j++].exec(ua);
            if (!!matches) {
              for (p = 0; p < props.length; p++) {
                match = matches[++k];
                q = props[p];
                // check if given property is actually array
                if (typeof q === OBJ_TYPE && q.length > 0) {
                  if (q.length === 2) {
                    if (typeof q[1] == FUNC_TYPE) {
                      // assign modified match
                      this[q[0]] = q[1].call(this, match);
                    } else {
                      // assign given value, ignore regex match
                      this[q[0]] = q[1];
                    }
                  } else if (q.length === 3) {
                    // check whether function or regex
                    if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
                      // call function (usually string mapper)
                      this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined$1;
                    } else {
                      // sanitize match using given regex
                      this[q[0]] = match ? match.replace(q[1], q[2]) : undefined$1;
                    }
                  } else if (q.length === 4) {
                    this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined$1;
                  }
                } else {
                  this[q] = match ? match : undefined$1;
                }
              }
            }
          }
          i += 2;
        }
      },
      strMapper = function strMapper(str, map) {
        for (var i in map) {
          // check if current value is array
          if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
            for (var j = 0; j < map[i].length; j++) {
              if (has(map[i][j], str)) {
                return i === UNKNOWN ? undefined$1 : i;
              }
            }
          } else if (has(map[i], str)) {
            return i === UNKNOWN ? undefined$1 : i;
          }
        }
        return str;
      };

    ///////////////
    // String map
    //////////////

    // Safari < 3.0
    var oldSafariMap = {
        '1.0': '/8',
        '1.2': '/1',
        '1.3': '/3',
        '2.0': '/412',
        '2.0.2': '/416',
        '2.0.3': '/417',
        '2.0.4': '/419',
        '?': '/'
      },
      windowsVersionMap = {
        'ME': '4.90',
        'NT 3.11': 'NT3.51',
        'NT 4.0': 'NT4.0',
        '2000': 'NT 5.0',
        'XP': ['NT 5.1', 'NT 5.2'],
        'Vista': 'NT 6.0',
        '7': 'NT 6.1',
        '8': 'NT 6.2',
        '8.1': 'NT 6.3',
        '10': ['NT 6.4', 'NT 10.0'],
        'RT': 'ARM'
      };

    //////////////
    // Regex map
    /////////////

    var regexes = {
      browser: [[/\b(?:crmo|crios)\/([\w\.]+)/i // Chrome for Android/iOS
      ], [VERSION, [NAME, 'Chrome']], [/edg(?:e|ios|a)?\/([\w\.]+)/i // Microsoft Edge
      ], [VERSION, [NAME, 'Edge']], [
      // Presto based
      /(opera mini)\/([-\w\.]+)/i,
      // Opera Mini
      /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
      // Opera Mobi/Tablet
      /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i // Opera
      ], [NAME, VERSION], [/opios[\/ ]+([\w\.]+)/i // Opera mini on iphone >= 8.0
      ], [VERSION, [NAME, OPERA + ' Mini']], [/\bop(?:rg)?x\/([\w\.]+)/i // Opera GX
      ], [VERSION, [NAME, OPERA + ' GX']], [/\bopr\/([\w\.]+)/i // Opera Webkit
      ], [VERSION, [NAME, OPERA]], [
      // Mixed
      /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i // Baidu
      ], [VERSION, [NAME, 'Baidu']], [/(kindle)\/([\w\.]+)/i,
      // Kindle
      /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,
      // Lunascape/Maxthon/Netfront/Jasmine/Blazer
      // Trident based
      /(avant|iemobile|slim)\s?(?:browser)?[\/ ]?([\w\.]*)/i,
      // Avant/IEMobile/SlimBrowser
      /(?:ms|\()(ie) ([\w\.]+)/i,
      // Internet Explorer

      // Webkit/KHTML based                                               // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
      /(flock|rockmelt|midori|epiphany|silk|skyfire|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i,
      // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ, aka ShouQ
      /(heytap|ovi)browser\/([\d\.]+)/i,
      // Heytap/Ovi
      /(weibo)__([\d\.]+)/i // Weibo
      ], [NAME, VERSION], [/\bddg\/([\w\.]+)/i // DuckDuckGo
      ], [VERSION, [NAME, 'DuckDuckGo']], [/(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i // UCBrowser
      ], [VERSION, [NAME, 'UC' + BROWSER]], [/microm.+\bqbcore\/([\w\.]+)/i,
      // WeChat Desktop for Windows Built-in Browser
      /\bqbcore\/([\w\.]+).+microm/i, /micromessenger\/([\w\.]+)/i // WeChat
      ], [VERSION, [NAME, 'WeChat']], [/konqueror\/([\w\.]+)/i // Konqueror
      ], [VERSION, [NAME, 'Konqueror']], [/trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i // IE11
      ], [VERSION, [NAME, 'IE']], [/ya(?:search)?browser\/([\w\.]+)/i // Yandex
      ], [VERSION, [NAME, 'Yandex']], [/slbrowser\/([\w\.]+)/i // Smart Lenovo Browser
      ], [VERSION, [NAME, 'Smart Lenovo ' + BROWSER]], [/(avast|avg)\/([\w\.]+)/i // Avast/AVG Secure Browser
      ], [[NAME, /(.+)/, '$1 Secure ' + BROWSER], VERSION], [/\bfocus\/([\w\.]+)/i // Firefox Focus
      ], [VERSION, [NAME, FIREFOX + ' Focus']], [/\bopt\/([\w\.]+)/i // Opera Touch
      ], [VERSION, [NAME, OPERA + ' Touch']], [/coc_coc\w+\/([\w\.]+)/i // Coc Coc Browser
      ], [VERSION, [NAME, 'Coc Coc']], [/dolfin\/([\w\.]+)/i // Dolphin
      ], [VERSION, [NAME, 'Dolphin']], [/coast\/([\w\.]+)/i // Opera Coast
      ], [VERSION, [NAME, OPERA + ' Coast']], [/miuibrowser\/([\w\.]+)/i // MIUI Browser
      ], [VERSION, [NAME, 'MIUI ' + BROWSER]], [/fxios\/([-\w\.]+)/i // Firefox for iOS
      ], [VERSION, [NAME, FIREFOX]], [/\bqihu|(qi?ho?o?|360)browser/i // 360
      ], [[NAME, '360 ' + BROWSER]], [/(oculus|sailfish|huawei|vivo)browser\/([\w\.]+)/i], [[NAME, /(.+)/, '$1 ' + BROWSER], VERSION], [
      // Oculus/Sailfish/HuaweiBrowser/VivoBrowser
      /samsungbrowser\/([\w\.]+)/i // Samsung Internet
      ], [VERSION, [NAME, SAMSUNG + ' Internet']], [/(comodo_dragon)\/([\w\.]+)/i // Comodo Dragon
      ], [[NAME, /_/g, ' '], VERSION], [/metasr[\/ ]?([\d\.]+)/i // Sogou Explorer
      ], [VERSION, [NAME, 'Sogou Explorer']], [/(sogou)mo\w+\/([\d\.]+)/i // Sogou Mobile
      ], [[NAME, 'Sogou Mobile'], VERSION], [/(electron)\/([\w\.]+) safari/i,
      // Electron-based App
      /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
      // Tesla
      /m?(qqbrowser|2345Explorer)[\/ ]?([\w\.]+)/i // QQBrowser/2345 Browser
      ], [NAME, VERSION], [/(lbbrowser)/i,
      // LieBao Browser
      /\[(linkedin)app\]/i // LinkedIn App for iOS & Android
      ], [NAME], [
      // WebView
      /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i // Facebook App for iOS & Android
      ], [[NAME, FACEBOOK], VERSION], [/(Klarna)\/([\w\.]+)/i,
      // Klarna Shopping Browser for iOS & Android
      /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
      // Kakao App
      /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
      // Naver InApp
      /safari (line)\/([\w\.]+)/i,
      // Line App for iOS
      /\b(line)\/([\w\.]+)\/iab/i,
      // Line App for Android
      /(alipay)client\/([\w\.]+)/i,
      // Alipay
      /(twitter)(?:and| f.+e\/([\w\.]+))/i,
      // Twitter
      /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i // Chromium/Instagram/Snapchat
      ], [NAME, VERSION], [/\bgsa\/([\w\.]+) .*safari\//i // Google Search Appliance on iOS
      ], [VERSION, [NAME, 'GSA']], [/musical_ly(?:.+app_?version\/|_)([\w\.]+)/i // TikTok
      ], [VERSION, [NAME, 'TikTok']], [/headlesschrome(?:\/([\w\.]+)| )/i // Chrome Headless
      ], [VERSION, [NAME, CHROME + ' Headless']], [/ wv\).+(chrome)\/([\w\.]+)/i // Chrome WebView
      ], [[NAME, CHROME + ' WebView'], VERSION], [/droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i // Android Browser
      ], [VERSION, [NAME, 'Android ' + BROWSER]], [/(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i // Chrome/OmniWeb/Arora/Tizen/Nokia
      ], [NAME, VERSION], [/version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i // Mobile Safari
      ], [VERSION, [NAME, 'Mobile Safari']], [/version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i // Safari & Safari Mobile
      ], [VERSION, NAME], [/webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i // Safari < 3.0
      ], [NAME, [VERSION, strMapper, oldSafariMap]], [/(webkit|khtml)\/([\w\.]+)/i], [NAME, VERSION], [
      // Gecko based
      /(navigator|netscape\d?)\/([-\w\.]+)/i // Netscape
      ], [[NAME, 'Netscape'], VERSION], [/mobile vr; rv:([\w\.]+)\).+firefox/i // Firefox Reality
      ], [VERSION, [NAME, FIREFOX + ' Reality']], [/ekiohf.+(flow)\/([\w\.]+)/i,
      // Flow
      /(swiftfox)/i,
      // Swiftfox
      /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
      // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror/Klar
      /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
      // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
      /(firefox)\/([\w\.]+)/i,
      // Other Firefox-based
      /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
      // Mozilla

      // Other
      /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
      // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir/Obigo/Mosaic/Go/ICE/UP.Browser
      /(links) \(([\w\.]+)/i,
      // Links
      /panasonic;(viera)/i // Panasonic Viera
      ], [NAME, VERSION], [/(cobalt)\/([\w\.]+)/i // Cobalt
      ], [NAME, [VERSION, /master.|lts./, ""]]],
      cpu: [[/(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i // AMD64 (x64)
      ], [[ARCHITECTURE, 'amd64']], [/(ia32(?=;))/i // IA32 (quicktime)
      ], [[ARCHITECTURE, lowerize]], [/((?:i[346]|x)86)[;\)]/i // IA32 (x86)
      ], [[ARCHITECTURE, 'ia32']], [/\b(aarch64|arm(v?8e?l?|_?64))\b/i // ARM64
      ], [[ARCHITECTURE, 'arm64']], [/\b(arm(?:v[67])?ht?n?[fl]p?)\b/i // ARMHF
      ], [[ARCHITECTURE, 'armhf']], [
      // PocketPC mistakenly identified as PowerPC
      /windows (ce|mobile); ppc;/i], [[ARCHITECTURE, 'arm']], [/((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i // PowerPC
      ], [[ARCHITECTURE, /ower/, EMPTY, lowerize]], [/(sun4\w)[;\)]/i // SPARC
      ], [[ARCHITECTURE, 'sparc']], [/((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
      // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
      ], [[ARCHITECTURE, lowerize]]],
      device: [[
      //////////////////////////
      // MOBILES & TABLETS
      /////////////////////////

      // Samsung
      /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i], [MODEL, [VENDOR, SAMSUNG], [TYPE, TABLET]], [/\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i, /samsung[- ]([-\w]+)/i, /sec-(sgh\w+)/i], [MODEL, [VENDOR, SAMSUNG], [TYPE, MOBILE]], [
      // Apple
      /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i // iPod/iPhone
      ], [MODEL, [VENDOR, APPLE], [TYPE, MOBILE]], [/\((ipad);[-\w\),; ]+apple/i,
      // iPad
      /applecoremedia\/[\w\.]+ \((ipad)/i, /\b(ipad)\d\d?,\d\d?[;\]].+ios/i], [MODEL, [VENDOR, APPLE], [TYPE, TABLET]], [/(macintosh);/i], [MODEL, [VENDOR, APPLE]], [
      // Sharp
      /\b(sh-?[altvz]?\d\d[a-ekm]?)/i], [MODEL, [VENDOR, SHARP], [TYPE, MOBILE]], [
      // Huawei
      /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i], [MODEL, [VENDOR, HUAWEI], [TYPE, TABLET]], [/(?:huawei|honor)([-\w ]+)[;\)]/i, /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i], [MODEL, [VENDOR, HUAWEI], [TYPE, MOBILE]], [
      // Xiaomi
      /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
      // Xiaomi POCO
      /\b; (\w+) build\/hm\1/i,
      // Xiaomi Hongmi 'numeric' models
      /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
      // Xiaomi Hongmi
      /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
      // Xiaomi Redmi
      /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,
      // Xiaomi Redmi 'numeric' models
      /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i // Xiaomi Mi
      ], [[MODEL, /_/g, ' '], [VENDOR, XIAOMI], [TYPE, MOBILE]], [/oid[^\)]+; (2\d{4}(283|rpbf)[cgl])( bui|\))/i,
      // Redmi Pad
      /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i // Mi Pad tablets
      ], [[MODEL, /_/g, ' '], [VENDOR, XIAOMI], [TYPE, TABLET]], [
      // OPPO
      /; (\w+) bui.+ oppo/i, /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i], [MODEL, [VENDOR, 'OPPO'], [TYPE, MOBILE]], [/\b(opd2\d{3}a?) bui/i], [MODEL, [VENDOR, 'OPPO'], [TYPE, TABLET]], [
      // Vivo
      /vivo (\w+)(?: bui|\))/i, /\b(v[12]\d{3}\w?[at])(?: bui|;)/i], [MODEL, [VENDOR, 'Vivo'], [TYPE, MOBILE]], [
      // Realme
      /\b(rmx[1-3]\d{3})(?: bui|;|\))/i], [MODEL, [VENDOR, 'Realme'], [TYPE, MOBILE]], [
      // Motorola
      /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i, /\bmot(?:orola)?[- ](\w*)/i, /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i], [MODEL, [VENDOR, MOTOROLA], [TYPE, MOBILE]], [/\b(mz60\d|xoom[2 ]{0,2}) build\//i], [MODEL, [VENDOR, MOTOROLA], [TYPE, TABLET]], [
      // LG
      /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i], [MODEL, [VENDOR, LG], [TYPE, TABLET]], [/(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i, /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i, /\blg-?([\d\w]+) bui/i], [MODEL, [VENDOR, LG], [TYPE, MOBILE]], [
      // Lenovo
      /(ideatab[-\w ]+)/i, /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i], [MODEL, [VENDOR, 'Lenovo'], [TYPE, TABLET]], [
      // Nokia
      /(?:maemo|nokia).*(n900|lumia \d+)/i, /nokia[-_ ]?([-\w\.]*)/i], [[MODEL, /_/g, ' '], [VENDOR, 'Nokia'], [TYPE, MOBILE]], [
      // Google
      /(pixel c)\b/i // Google Pixel C
      ], [MODEL, [VENDOR, GOOGLE], [TYPE, TABLET]], [/droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i // Google Pixel
      ], [MODEL, [VENDOR, GOOGLE], [TYPE, MOBILE]], [
      // Sony
      /droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i], [MODEL, [VENDOR, SONY], [TYPE, MOBILE]], [/sony tablet [ps]/i, /\b(?:sony)?sgp\w+(?: bui|\))/i], [[MODEL, 'Xperia Tablet'], [VENDOR, SONY], [TYPE, TABLET]], [
      // OnePlus
      / (kb2005|in20[12]5|be20[12][59])\b/i, /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i], [MODEL, [VENDOR, 'OnePlus'], [TYPE, MOBILE]], [
      // Amazon
      /(alexa)webm/i, /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i,
      // Kindle Fire without Silk / Echo Show
      /(kf[a-z]+)( bui|\)).+silk\//i // Kindle Fire HD
      ], [MODEL, [VENDOR, AMAZON], [TYPE, TABLET]], [/((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i // Fire Phone
      ], [[MODEL, /(.+)/g, 'Fire Phone $1'], [VENDOR, AMAZON], [TYPE, MOBILE]], [
      // BlackBerry
      /(playbook);[-\w\),; ]+(rim)/i // BlackBerry PlayBook
      ], [MODEL, VENDOR, [TYPE, TABLET]], [/\b((?:bb[a-f]|st[hv])100-\d)/i, /\(bb10; (\w+)/i // BlackBerry 10
      ], [MODEL, [VENDOR, BLACKBERRY], [TYPE, MOBILE]], [
      // Asus
      /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i], [MODEL, [VENDOR, ASUS], [TYPE, TABLET]], [/ (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i], [MODEL, [VENDOR, ASUS], [TYPE, MOBILE]], [
      // HTC
      /(nexus 9)/i // HTC Nexus 9
      ], [MODEL, [VENDOR, 'HTC'], [TYPE, TABLET]], [/(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
      // HTC

      // ZTE
      /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i, /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
      ], [VENDOR, [MODEL, /_/g, ' '], [TYPE, MOBILE]], [
      // Acer
      /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i], [MODEL, [VENDOR, 'Acer'], [TYPE, TABLET]], [
      // Meizu
      /droid.+; (m[1-5] note) bui/i, /\bmz-([-\w]{2,})/i], [MODEL, [VENDOR, 'Meizu'], [TYPE, MOBILE]], [
      // Ulefone
      /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i], [MODEL, [VENDOR, 'Ulefone'], [TYPE, MOBILE]], [
      // MIXED
      /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno)[-_ ]?([-\w]*)/i,
      // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
      /(hp) ([\w ]+\w)/i,
      // HP iPAQ
      /(asus)-?(\w+)/i,
      // Asus
      /(microsoft); (lumia[\w ]+)/i,
      // Microsoft Lumia
      /(lenovo)[-_ ]?([-\w]+)/i,
      // Lenovo
      /(jolla)/i,
      // Jolla
      /(oppo) ?([\w ]+) bui/i // OPPO
      ], [VENDOR, MODEL, [TYPE, MOBILE]], [/(kobo)\s(ereader|touch)/i,
      // Kobo
      /(archos) (gamepad2?)/i,
      // Archos
      /(hp).+(touchpad(?!.+tablet)|tablet)/i,
      // HP TouchPad
      /(kindle)\/([\w\.]+)/i,
      // Kindle
      /(nook)[\w ]+build\/(\w+)/i,
      // Nook
      /(dell) (strea[kpr\d ]*[\dko])/i,
      // Dell Streak
      /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
      // Le Pan Tablets
      /(trinity)[- ]*(t\d{3}) bui/i,
      // Trinity Tablets
      /(gigaset)[- ]+(q\w{1,9}) bui/i,
      // Gigaset Tablets
      /(vodafone) ([\w ]+)(?:\)| bui)/i // Vodafone
      ], [VENDOR, MODEL, [TYPE, TABLET]], [/(surface duo)/i // Surface Duo
      ], [MODEL, [VENDOR, MICROSOFT], [TYPE, TABLET]], [/droid [\d\.]+; (fp\du?)(?: b|\))/i // Fairphone
      ], [MODEL, [VENDOR, 'Fairphone'], [TYPE, MOBILE]], [/(u304aa)/i // AT&T
      ], [MODEL, [VENDOR, 'AT&T'], [TYPE, MOBILE]], [/\bsie-(\w*)/i // Siemens
      ], [MODEL, [VENDOR, 'Siemens'], [TYPE, MOBILE]], [/\b(rct\w+) b/i // RCA Tablets
      ], [MODEL, [VENDOR, 'RCA'], [TYPE, TABLET]], [/\b(venue[\d ]{2,7}) b/i // Dell Venue Tablets
      ], [MODEL, [VENDOR, 'Dell'], [TYPE, TABLET]], [/\b(q(?:mv|ta)\w+) b/i // Verizon Tablet
      ], [MODEL, [VENDOR, 'Verizon'], [TYPE, TABLET]], [/\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i // Barnes & Noble Tablet
      ], [MODEL, [VENDOR, 'Barnes & Noble'], [TYPE, TABLET]], [/\b(tm\d{3}\w+) b/i], [MODEL, [VENDOR, 'NuVision'], [TYPE, TABLET]], [/\b(k88) b/i // ZTE K Series Tablet
      ], [MODEL, [VENDOR, 'ZTE'], [TYPE, TABLET]], [/\b(nx\d{3}j) b/i // ZTE Nubia
      ], [MODEL, [VENDOR, 'ZTE'], [TYPE, MOBILE]], [/\b(gen\d{3}) b.+49h/i // Swiss GEN Mobile
      ], [MODEL, [VENDOR, 'Swiss'], [TYPE, MOBILE]], [/\b(zur\d{3}) b/i // Swiss ZUR Tablet
      ], [MODEL, [VENDOR, 'Swiss'], [TYPE, TABLET]], [/\b((zeki)?tb.*\b) b/i // Zeki Tablets
      ], [MODEL, [VENDOR, 'Zeki'], [TYPE, TABLET]], [/\b([yr]\d{2}) b/i, /\b(dragon[- ]+touch |dt)(\w{5}) b/i // Dragon Touch Tablet
      ], [[VENDOR, 'Dragon Touch'], MODEL, [TYPE, TABLET]], [/\b(ns-?\w{0,9}) b/i // Insignia Tablets
      ], [MODEL, [VENDOR, 'Insignia'], [TYPE, TABLET]], [/\b((nxa|next)-?\w{0,9}) b/i // NextBook Tablets
      ], [MODEL, [VENDOR, 'NextBook'], [TYPE, TABLET]], [/\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i // Voice Xtreme Phones
      ], [[VENDOR, 'Voice'], MODEL, [TYPE, MOBILE]], [/\b(lvtel\-)?(v1[12]) b/i // LvTel Phones
      ], [[VENDOR, 'LvTel'], MODEL, [TYPE, MOBILE]], [/\b(ph-1) /i // Essential PH-1
      ], [MODEL, [VENDOR, 'Essential'], [TYPE, MOBILE]], [/\b(v(100md|700na|7011|917g).*\b) b/i // Envizen Tablets
      ], [MODEL, [VENDOR, 'Envizen'], [TYPE, TABLET]], [/\b(trio[-\w\. ]+) b/i // MachSpeed Tablets
      ], [MODEL, [VENDOR, 'MachSpeed'], [TYPE, TABLET]], [/\btu_(1491) b/i // Rotor Tablets
      ], [MODEL, [VENDOR, 'Rotor'], [TYPE, TABLET]], [/(shield[\w ]+) b/i // Nvidia Shield Tablets
      ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, TABLET]], [/(sprint) (\w+)/i // Sprint Phones
      ], [VENDOR, MODEL, [TYPE, MOBILE]], [/(kin\.[onetw]{3})/i // Microsoft Kin
      ], [[MODEL, /\./g, ' '], [VENDOR, MICROSOFT], [TYPE, MOBILE]], [/droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i // Zebra
      ], [MODEL, [VENDOR, ZEBRA], [TYPE, TABLET]], [/droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i], [MODEL, [VENDOR, ZEBRA], [TYPE, MOBILE]], [
      ///////////////////
      // SMARTTVS
      ///////////////////

      /smart-tv.+(samsung)/i // Samsung
      ], [VENDOR, [TYPE, SMARTTV]], [/hbbtv.+maple;(\d+)/i], [[MODEL, /^/, 'SmartTV'], [VENDOR, SAMSUNG], [TYPE, SMARTTV]], [/(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i // LG SmartTV
      ], [[VENDOR, LG], [TYPE, SMARTTV]], [/(apple) ?tv/i // Apple TV
      ], [VENDOR, [MODEL, APPLE + ' TV'], [TYPE, SMARTTV]], [/crkey/i // Google Chromecast
      ], [[MODEL, CHROME + 'cast'], [VENDOR, GOOGLE], [TYPE, SMARTTV]], [/droid.+aft(\w+)( bui|\))/i // Fire TV
      ], [MODEL, [VENDOR, AMAZON], [TYPE, SMARTTV]], [/\(dtv[\);].+(aquos)/i, /(aquos-tv[\w ]+)\)/i // Sharp
      ], [MODEL, [VENDOR, SHARP], [TYPE, SMARTTV]], [/(bravia[\w ]+)( bui|\))/i // Sony
      ], [MODEL, [VENDOR, SONY], [TYPE, SMARTTV]], [/(mitv-\w{5}) bui/i // Xiaomi
      ], [MODEL, [VENDOR, XIAOMI], [TYPE, SMARTTV]], [/Hbbtv.*(technisat) (.*);/i // TechniSAT
      ], [VENDOR, MODEL, [TYPE, SMARTTV]], [/\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
      // Roku
      /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i // HbbTV devices
      ], [[VENDOR, trim], [MODEL, trim], [TYPE, SMARTTV]], [/\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i // SmartTV from Unidentified Vendors
      ], [[TYPE, SMARTTV]], [
      ///////////////////
      // CONSOLES
      ///////////////////

      /(ouya)/i,
      // Ouya
      /(nintendo) ([wids3utch]+)/i // Nintendo
      ], [VENDOR, MODEL, [TYPE, CONSOLE]], [/droid.+; (shield) bui/i // Nvidia
      ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, CONSOLE]], [/(playstation [345portablevi]+)/i // Playstation
      ], [MODEL, [VENDOR, SONY], [TYPE, CONSOLE]], [/\b(xbox(?: one)?(?!; xbox))[\); ]/i // Microsoft Xbox
      ], [MODEL, [VENDOR, MICROSOFT], [TYPE, CONSOLE]], [
      ///////////////////
      // WEARABLES
      ///////////////////

      /((pebble))app/i // Pebble
      ], [VENDOR, MODEL, [TYPE, WEARABLE]], [/(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i // Apple Watch
      ], [MODEL, [VENDOR, APPLE], [TYPE, WEARABLE]], [/droid.+; (glass) \d/i // Google Glass
      ], [MODEL, [VENDOR, GOOGLE], [TYPE, WEARABLE]], [/droid.+; (wt63?0{2,3})\)/i], [MODEL, [VENDOR, ZEBRA], [TYPE, WEARABLE]], [/(quest( \d| pro)?)/i // Oculus Quest
      ], [MODEL, [VENDOR, FACEBOOK], [TYPE, WEARABLE]], [
      ///////////////////
      // EMBEDDED
      ///////////////////

      /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i // Tesla
      ], [VENDOR, [TYPE, EMBEDDED]], [/(aeobc)\b/i // Echo Dot
      ], [MODEL, [VENDOR, AMAZON], [TYPE, EMBEDDED]], [
      ////////////////////
      // MIXED (GENERIC)
      ///////////////////

      /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i // Android Phones from Unidentified Vendors
      ], [MODEL, [TYPE, MOBILE]], [/droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i // Android Tablets from Unidentified Vendors
      ], [MODEL, [TYPE, TABLET]], [/\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i // Unidentifiable Tablet
      ], [[TYPE, TABLET]], [/(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i // Unidentifiable Mobile
      ], [[TYPE, MOBILE]], [/(android[-\w\. ]{0,9});.+buil/i // Generic Android Device
      ], [MODEL, [VENDOR, 'Generic']]],
      engine: [[/windows.+ edge\/([\w\.]+)/i // EdgeHTML
      ], [VERSION, [NAME, EDGE + 'HTML']], [/webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i // Blink
      ], [VERSION, [NAME, 'Blink']], [/(presto)\/([\w\.]+)/i,
      // Presto
      /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,
      // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna
      /ekioh(flow)\/([\w\.]+)/i,
      // Flow
      /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
      // KHTML/Tasman/Links
      /(icab)[\/ ]([23]\.[\d\.]+)/i,
      // iCab
      /\b(libweb)/i], [NAME, VERSION], [/rv\:([\w\.]{1,9})\b.+(gecko)/i // Gecko
      ], [VERSION, NAME]],
      os: [[
      // Windows
      /microsoft (windows) (vista|xp)/i // Windows (iTunes)
      ], [NAME, VERSION], [/(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i // Windows Phone
      ], [NAME, [VERSION, strMapper, windowsVersionMap]], [/windows nt 6\.2; (arm)/i,
      // Windows RT
      /windows[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i, /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i], [[VERSION, strMapper, windowsVersionMap], [NAME, 'Windows']], [
      // iOS/macOS
      /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,
      // iOS
      /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i, /cfnetwork\/.+darwin/i], [[VERSION, /_/g, '.'], [NAME, 'iOS']], [/(mac os x) ?([\w\. ]*)/i, /(macintosh|mac_powerpc\b)(?!.+haiku)/i // Mac OS
      ], [[NAME, MAC_OS], [VERSION, /_/g, '.']], [
      // Mobile OSes
      /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i // Android-x86/HarmonyOS
      ], [VERSION, NAME], [
      // Android/WebOS/QNX/Bada/RIM/Maemo/MeeGo/Sailfish OS
      /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i, /(blackberry)\w*\/([\w\.]*)/i,
      // Blackberry
      /(tizen|kaios)[\/ ]([\w\.]+)/i,
      // Tizen/KaiOS
      /\((series40);/i // Series 40
      ], [NAME, VERSION], [/\(bb(10);/i // BlackBerry 10
      ], [VERSION, [NAME, BLACKBERRY]], [/(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i // Symbian
      ], [VERSION, [NAME, 'Symbian']], [/mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i // Firefox OS
      ], [VERSION, [NAME, FIREFOX + ' OS']], [/web0s;.+rt(tv)/i, /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i // WebOS
      ], [VERSION, [NAME, 'webOS']], [/watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i // watchOS
      ], [VERSION, [NAME, 'watchOS']], [
      // Google Chromecast
      /crkey\/([\d\.]+)/i // Google Chromecast
      ], [VERSION, [NAME, CHROME + 'cast']], [/(cros) [\w]+(?:\)| ([\w\.]+)\b)/i // Chromium OS
      ], [[NAME, CHROMIUM_OS], VERSION], [
      // Smart TVs
      /panasonic;(viera)/i,
      // Panasonic Viera
      /(netrange)mmh/i,
      // Netrange
      /(nettv)\/(\d+\.[\w\.]+)/i,
      // NetTV

      // Console
      /(nintendo|playstation) ([wids345portablevuch]+)/i,
      // Nintendo/Playstation
      /(xbox); +xbox ([^\);]+)/i,
      // Microsoft Xbox (360, One, X, S, Series X, Series S)

      // Other
      /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
      // Joli/Palm
      /(mint)[\/\(\) ]?(\w*)/i,
      // Mint
      /(mageia|vectorlinux)[; ]/i,
      // Mageia/VectorLinux
      /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
      // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
      /(hurd|linux) ?([\w\.]*)/i,
      // Hurd/Linux
      /(gnu) ?([\w\.]*)/i,
      // GNU
      /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
      // FreeBSD/NetBSD/OpenBSD/PC-BSD/GhostBSD/DragonFly
      /(haiku) (\w+)/i // Haiku
      ], [NAME, VERSION], [/(sunos) ?([\w\.\d]*)/i // Solaris
      ], [[NAME, 'Solaris'], VERSION], [/((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
      // Solaris
      /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
      // AIX
      /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
      // BeOS/OS2/AmigaOS/MorphOS/OpenVMS/Fuchsia/HP-UX/SerenityOS
      /(unix) ?([\w\.]*)/i // UNIX
      ], [NAME, VERSION]]
    };

    /////////////////
    // Constructor
    ////////////////

    var _UAParser = function UAParser(ua, extensions) {
      if (typeof ua === OBJ_TYPE) {
        extensions = ua;
        ua = undefined$1;
      }
      if (!(this instanceof _UAParser)) {
        return new _UAParser(ua, extensions).getResult();
      }
      var _navigator = typeof window !== UNDEF_TYPE && window.navigator ? window.navigator : undefined$1;
      var _ua = ua || (_navigator && _navigator.userAgent ? _navigator.userAgent : EMPTY);
      var _uach = _navigator && _navigator.userAgentData ? _navigator.userAgentData : undefined$1;
      var _rgxmap = extensions ? extend(regexes, extensions) : regexes;
      var _isSelfNav = _navigator && _navigator.userAgent == _ua;
      this.getBrowser = function () {
        var _browser = {};
        _browser[NAME] = undefined$1;
        _browser[VERSION] = undefined$1;
        rgxMapper.call(_browser, _ua, _rgxmap.browser);
        _browser[MAJOR] = majorize(_browser[VERSION]);
        // Brave-specific detection
        if (_isSelfNav && _navigator && _navigator.brave && typeof _navigator.brave.isBrave == FUNC_TYPE) {
          _browser[NAME] = 'Brave';
        }
        return _browser;
      };
      this.getCPU = function () {
        var _cpu = {};
        _cpu[ARCHITECTURE] = undefined$1;
        rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
        return _cpu;
      };
      this.getDevice = function () {
        var _device = {};
        _device[VENDOR] = undefined$1;
        _device[MODEL] = undefined$1;
        _device[TYPE] = undefined$1;
        rgxMapper.call(_device, _ua, _rgxmap.device);
        if (_isSelfNav && !_device[TYPE] && _uach && _uach.mobile) {
          _device[TYPE] = MOBILE;
        }
        // iPadOS-specific detection: identified as Mac, but has some iOS-only properties
        if (_isSelfNav && _device[MODEL] == 'Macintosh' && _navigator && typeof _navigator.standalone !== UNDEF_TYPE && _navigator.maxTouchPoints && _navigator.maxTouchPoints > 2) {
          _device[MODEL] = 'iPad';
          _device[TYPE] = TABLET;
        }
        return _device;
      };
      this.getEngine = function () {
        var _engine = {};
        _engine[NAME] = undefined$1;
        _engine[VERSION] = undefined$1;
        rgxMapper.call(_engine, _ua, _rgxmap.engine);
        return _engine;
      };
      this.getOS = function () {
        var _os = {};
        _os[NAME] = undefined$1;
        _os[VERSION] = undefined$1;
        rgxMapper.call(_os, _ua, _rgxmap.os);
        if (_isSelfNav && !_os[NAME] && _uach && _uach.platform && _uach.platform != 'Unknown') {
          _os[NAME] = _uach.platform.replace(/chrome os/i, CHROMIUM_OS).replace(/macos/i, MAC_OS); // backward compatibility
        }
        return _os;
      };
      this.getResult = function () {
        return {
          ua: this.getUA(),
          browser: this.getBrowser(),
          engine: this.getEngine(),
          os: this.getOS(),
          device: this.getDevice(),
          cpu: this.getCPU()
        };
      };
      this.getUA = function () {
        return _ua;
      };
      this.setUA = function (ua) {
        _ua = typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH ? trim(ua, UA_MAX_LENGTH) : ua;
        return this;
      };
      this.setUA(_ua);
      return this;
    };
    _UAParser.VERSION = LIBVERSION;
    _UAParser.BROWSER = enumerize([NAME, VERSION, MAJOR]);
    _UAParser.CPU = enumerize([ARCHITECTURE]);
    _UAParser.DEVICE = enumerize([MODEL, VENDOR, TYPE, CONSOLE, MOBILE, SMARTTV, TABLET, WEARABLE, EMBEDDED]);
    _UAParser.ENGINE = _UAParser.OS = enumerize([NAME, VERSION]);

    ///////////
    // Export
    //////////

    // check js environment
    {
      // nodejs env
      if (module.exports) {
        exports = module.exports = _UAParser;
      }
      exports.UAParser = _UAParser;
    }

    // jQuery/Zepto specific (optional)
    // Note:
    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
    //   and we should catch that.
    var $ = typeof window !== UNDEF_TYPE && (window.jQuery || window.Zepto);
    if ($ && !$.ua) {
      var parser = new _UAParser();
      $.ua = parser.getResult();
      $.ua.get = function () {
        return parser.getUA();
      };
      $.ua.set = function (ua) {
        parser.setUA(ua);
        var result = parser.getResult();
        for (var prop in result) {
          $.ua[prop] = result[prop];
        }
      };
    }
  })(typeof window === 'object' ? window : commonjsGlobal);
})(uaParser$1, uaParser$1.exports);
var uaParserExports = uaParser$1.exports;
var uaParser = /*@__PURE__*/getDefaultExportFromCjs(uaParserExports);
function _typeof$1(o) {
  "@babel/helpers - typeof";

  return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof$1(o);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function ownKeys$1(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread$1(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$1(Object(t), !0).forEach(function (r) {
      _defineProperty$1(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty$1(e, r, t) {
  return (r = _toPropertyKey$1(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey$1(t) {
  var i = _toPrimitive$1(t, "string");
  return "symbol" == _typeof$1(i) ? i : i + "";
}
function _toPrimitive$1(t, r) {
  if ("object" != _typeof$1(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof$1(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var DEFAULT_BRAND = mbpUtil.getEnv('APP_BRAND_TOKEN') || 'flowers';
var DEFAULT_STORE_ID = mbpUtil.getEnv('APP_STORE_ID') || '20051';
var brands = {
  thepopcornfactory: ['thepopcornfactory', 10201],
  cheryls: ['cheryls', 10202],
  flowers: ['flowers', 20051],
  fanniemay: ['fanniemay', 20052],
  baskets: ['baskets', 20054],
  fruitbouquets: ['fruitbouquets', 20551],
  simplychocolate: ['simplychocolate', 24052],
  harryanddavid: ['harryanddavid', 21051],
  wolfermans: ['wolfermans', 21551],
  stockyards: ['stockyards', 22051],
  celebrations: ['celebrations', 22551],
  napco: ['napco', 23552],
  berries: ['berries', 25052],
  'loadtest1.origin': ['harryanddavid', 21051]
};

// const WC_ENV_OBJ = {
//     protocol: undefined,
//     host: undefined,
//     rootUri: '/wcs/resources/store/',
//     storeId: undefined,
//     brand: undefined,
//     prefix: undefined,
// };

var HTTP_HEADER_ACCEPTED_ENCODING = 'gzip, deflate';

/**
 * Find host from either:
 *  1. window object
 *  2. env var (wc_host)
 *  3. default: localhost
*/
var getBrandHost = function getBrandHost() {
  var windowHostname = typeof window !== 'undefined' && window.location && window.location.hostname;
  mbpLogger.logDebug({
    windowHostname: windowHostname,
    "function": 'getBrandHost',
    module: 'wc-api',
    message: 'getBrandHost | windowHostname'
  });

  // Handle common SSR host (proxyserver.common)
  if (!windowHostname) {
    mbpLogger.logDebug({
      'global.mbp': global.mbp || null,
      "function": 'getBrandHost',
      module: 'wc-api',
      message: 'getBrandHost | !host'
    });
    var ssrConfig = global.mbp.ssrConfig;
    mbpLogger.logDebug({
      ssrConfig: ssrConfig,
      "function": 'getBrandHost',
      module: 'wc-api',
      message: 'Determine true SSR domain'
    });
    if (ssrConfig && ssrConfig.hostName) {
      return ssrConfig.hostName;
    }
  }
  if (windowHostname) {
    return windowHostname;
  }
  return null;
};

/**
 * Find host from either:
 *  1. window object
 *  2. env var (wc_host)
 *  3. default: localhost
*/
var getHost = function getHost() {
  var windowHostname = typeof window !== 'undefined' && window.location && window.location.hostname;
  if (!windowHostname) {
    return process.env.APP_WC_HOST_SSR || 'localhost';
  }
  var wcHost = mbpUtil.getEnv('APP_WC_HOST');
  return wcHost || windowHostname || 'localhost';
};
var getProtocol = function getProtocol() {
  // SSR
  if (typeof window === 'undefined') {
    return process.env.APP_WC_PROTOCOL_SSR || 'https';
  }
  return mbpUtil.getEnv('APP_WC_PROTOCOL') || 'https';
};
var getPrefix = function getPrefix() {
  // SSR
  if (typeof window === 'undefined') {
    return process.env.APP_API_PREFIX_SSR || '';
  }
  return mbpUtil.getEnv('APP_API_PREFIX') || '/r/api';
};
var getShopperManagerCookie = function getShopperManagerCookie() {
  var COOKIE_NAME = 'ShopperManagerEnterprise';
  var cookies = new Cookies();
  return cookies.get(COOKIE_NAME) || '';
};
var getDeviceType = function getDeviceType() {
  if (typeof navigator !== 'undefined') {
    var navigatorUserAgent = navigator.userAgent;
    var _uaParser = uaParser(navigatorUserAgent),
      device = _uaParser.device,
      browser = _uaParser.browser;
    var deviceType = device && device.type ? device.type : '';
    var browserName = browser && browser.name ? browser.name : '';

    // Return Device Type
    if (['mobile', 'tablet'].indexOf(deviceType) >= 0) {
      return device.type;
    }
    if (!browserName.toLowerCase().includes('mobile')) {
      return 'desktop';
    }
  }
  return 'unknown';
};
var getVersion = function getVersion() {
  var appVersion = mbpUtil.getEnv('APP_VERSION_ENV') || '';
  var deviceType = getDeviceType();
  return "".concat(appVersion, "-").concat(deviceType);
};
var getHeaders = function getHeaders(headersInput) {
  var headers = _objectSpread$1(_objectSpread$1({}, headersInput), {}, {
    'baggage-sessionid': getShopperManagerCookie()
  });
  var appVersion = getVersion();
  if (appVersion) {
    headers['app-version'] = appVersion;
  }
  if (typeof window === 'undefined') {
    headers['Accept-Encoding'] = HTTP_HEADER_ACCEPTED_ENCODING;
  }
  return headers;
};
var getRootUri = function getRootUri() {
  return '/wcs/resources/store/';
};
var getBrandFromHost = function getBrandFromHost(inHost) {
  mbpLogger.logDebug({
    inHost: inHost,
    "function": 'getBrandFromHost',
    module: 'wc-api',
    message: 'getBrandFromHost | START'
  });
  var brandFromHost = DEFAULT_BRAND;
  var host = getBrandHost();
  if (host) {
    var tempHost = host.toLowerCase();

    // Search through brands object to find current brand
    Object.keys(brands).forEach(function (brand) {
      var _brands$brand = _slicedToArray(brands[brand], 1),
        token = _brands$brand[0];
      if (tempHost.includes(brand)) {
        mbpLogger.logDebug({
          brand: brand,
          "function": 'getBrandFromHost',
          module: 'wc-api',
          message: 'getBrandFromHost | tempHost.includes(brand)'
        });
        // Set Brand Token
        brandFromHost = token || DEFAULT_BRAND;
      }
    });
  }
  mbpLogger.logDebug({
    brandFromHost: brandFromHost,
    "function": 'getBrandFromHost',
    module: 'wc-api',
    message: 'getBrandFromHost | END'
  });
  return brandFromHost;
};
var getStoreIdFromHost = function getStoreIdFromHost(inHost) {
  mbpLogger.logDebug({
    inHost: inHost,
    "function": 'getStoreIdFromHost',
    module: 'wc-api',
    message: 'getStoreIdFromHost | START'
  });
  var storeIdFromHost = DEFAULT_STORE_ID;
  var host = getBrandHost();
  if (host) {
    var tempHost = host.toLowerCase();

    // Search through brands object to find current brand
    Object.keys(brands).forEach(function (brand) {
      var _brands$brand2 = _slicedToArray(brands[brand], 2),
        storeId = _brands$brand2[1];
      if (tempHost.includes(brand)) {
        mbpLogger.logDebug({
          brand: brand,
          "function": 'getStoreIdFromHost',
          module: 'wc-api',
          message: 'getStoreIdFromHost | host.includes(brand)'
        });
        storeIdFromHost = storeId || DEFAULT_STORE_ID;
      }
    });
  }
  mbpLogger.logDebug({
    storeIdFromHost: storeIdFromHost,
    "function": 'getStoreIdFromHost',
    module: 'wc-api',
    message: 'getStoreIdFromHost | END'
  });
  return storeIdFromHost;
};

/**
 * add jwtToken as a header
 * @param {*} jwt_token
 * @param {*} config
 */
var addJwtToken = function addJwtToken(jwtToken) {
  if (!jwtToken || jwtToken === '') {
    return 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImtpZCI6Ik16ZENSRUZGTWpkRVJUaERNalJDUWpSQ016TkJNakE1TURrMk5FWTNORFF6UVVZNE9UYzVNQSJ9.eyJodHRwczovLzgwMC1mbG93ZXJzLm5ldCI6eyJ0eXBlIjoiZ3Vlc3QiLCJzeXN0ZW1JRCI6IkFVVEgwLUdVRVNULTEwMDAwMDAwMDAwMDAwMDI5MjIiLCJjb250YWN0SWQiOiJHVUVTVC0xMDAwMDAwMDAwMDAwMDAyOTIyIn0sImlzcyI6Imh0dHBzOi8vZmxvd2Vyc3Rlc3QuYXV0aDAuY29tLyIsInN1YiI6Imdsb2lVRGxSeDdoaklBR3JlUDRpZ2o0c0RGdTlzYzN4QGNsaWVudHMiLCJhdWQiOiJodHRwczovL2RldjEub3JpZ2luLWdjcC44MDAtZmxvd2Vycy5uZXQiLCJpYXQiOjE1MzcyMTczMjUsImV4cCI6MTUzNzMwMzcyNSwiYXpwIjoiZ2xvaVVEbFJ4N2hqSUFHcmVQNGlnajRzREZ1OXNjM3giLCJzY29wZSI6ImN1c3RvbWVyOmNoZWNrb3V0IiwiZ3R5IjoiY2xpZW50LWNyZWRlbnRpYWxzIn0.NavrE2LDwYJM5e3WP9DD2cPBikUkGOv-bwfCoUSfWNx04iXWZRo_CKYOzKlKFHn78q2ChGI3otzP_x5Yb69Hl4EcfSXJ4by4PDBk5Vu9CQ3s4VWFpYyzycxsGLmLU_pGLiM44mpfQ8OWv_SMJyQKqcYiRNupUS2P2K1Jgus4l-gCRIkCgJ6IHpA7h9N9BK-WCpU32EDQXUIGWTwMU1i_861w0sWVD2NqP3ugxqQC_gahQ4y4m7_MBKTiPfdUhmQkaN82A-j7_5ndcO9QaDDcRzGwuvMxTmKQMqSNifGZMsNjO0UzdZD6HigOi_L-2iDm9NCo27gxajseuEPKrcSVbg';
  }
  return "Bearer ".concat(jwtToken);
};

/**
 * add brand as param
 * brand is either passed in by client or determined using window hostname
 * @param {*} wcEnv
 */
var addBrand = function addBrand(wcEnv) {
  return wcEnv.brand || getBrandFromHost() || DEFAULT_BRAND;
};

/**
 * parseParams to allow repeat same parameter in this case for the face filter.
 *
 * @param params    - object with parameters to be added to the url
 */
var parseParams = function parseParams(params) {
  var keys = Object.keys(params);
  var options = '';
  keys.forEach(function (key) {
    var isParamTypeObject = _typeof$1(params[key]) === 'object';
    var isParamTypeArray = isParamTypeObject && params[key].length >= 0;
    if (!isParamTypeObject) {
      options += "".concat(key, "=").concat(encodeURIComponent(params[key]), "&");
    }
    if (isParamTypeObject && isParamTypeArray) {
      params[key].forEach(function (element) {
        options += "".concat(key, "=").concat(encodeURIComponent(element), "&");
      });
    }
  });
  return options ? options.slice(0, -1) : options;
};

/**
 * Call Axios to execute remote call to WC service.
 * Note: brand will get added as parameter on the URL
 *
 * @param method    - get/post/put/delete/etc
 * @param url       - string for url to call
 * @param params    - object with parameters to be added to the url
 * @param data      - body
 * @param wcEnv     - WC environment properties
 * @param jwtToken  - JWT Access Token
 * @param header    - object with headers to be added to the request
 */
var callAxios = function callAxios(method, url, params, data, wcEnv, jwtToken, headers) {
  try {
    var allHeaders = getHeaders(headers);
    if (url.indexOf('://cdn') >= 0) {
      // removing baggage-sessionid for cdn urls
      delete allHeaders['baggage-sessionid'];
    }
    // Bail if no GUID or JWT provided
    if (data && !data.guid && !jwtToken) {
      return false;
    }
    var reqParams = !params ? {} : params;
    var config = {
      method: method,
      url: url,
      params: _objectSpread$1({
        brand: addBrand(wcEnv)
      }, reqParams),
      // eslint-disable-next-line no-shadow
      paramsSerializer: reqParams.facet ? function (reqParams) {
        return parseParams(reqParams);
      } : null,
      headers: allHeaders,
      data: data
    };
    if (!reqParams && jwtToken || reqParams && !reqParams.suppressJWT && jwtToken) {
      config.headers = _objectSpread$1({
        Authorization: addJwtToken(jwtToken)
      }, config.headers);
    }
    return axios(config);
  } catch (ex) {
    mbpLogger.logError({
      method: method,
      url: url,
      params: params,
      data: data,
      wcEnv: wcEnv,
      jwtToken: jwtToken,
      headers: headers,
      "function": 'callAxios',
      module: 'wc-api',
      jsError: ex,
      message: 'callAxios FAILED'
    });
  }
  return null;
};

/**
 * Builds the url
 * FIXME: move addition of storeId from wcEnv to wc-api client functions.
 * @param {*} wcEnv  - if empty uses default.
 * @param String resourcePath
 */
var getUrl = function getUrl(wcEnv, resourcePath) {
  mbpLogger.logDebug({
    wcEnv: wcEnv,
    resourcePath: resourcePath,
    "function": 'getUrl',
    module: 'wc-api',
    message: 'getUrl variables'
  });
  var apiHost = wcEnv.host || getHost();
  var apiHostUrl = "".concat(wcEnv.protocol || getProtocol(), "://").concat(apiHost);
  var uri = "".concat(wcEnv.prefix || getPrefix()).concat(wcEnv.rootUri || getRootUri()).concat(wcEnv.storeId || getStoreIdFromHost());
  var url = "".concat(apiHostUrl).concat(uri, "/").concat(resourcePath);
  mbpLogger.logDebug({
    url: url,
    uri: uri,
    apiHostUrl: apiHostUrl,
    "function": 'getUrl',
    module: 'wc-api',
    message: 'getUrl variables'
  });
  return url;
};

/**
 * GET for WC api calls
 * @param {*} wcEnv
 * @param {*} resourcePath
 * @param {*} params
 */
var wcGet = function wcGet(wcEnv, resourcePath, jwtToken, params) {
  try {
    mbpLogger.logDebug({
      wcEnv: wcEnv,
      resourcePath: resourcePath,
      jwtToken: jwtToken,
      params: params,
      "function": 'wcGet',
      module: 'wc-api',
      message: 'wcGet params'
    });
    var url = getUrl(wcEnv, resourcePath);
    mbpLogger.logDebug({
      url: url,
      "function": 'wcGet',
      module: 'wc-api',
      message: 'wcGet | url'
    });
    return callAxios('get', url, params, null, wcEnv, jwtToken);
  } catch (ex) {
    mbpLogger.logError({
      wcEnv: wcEnv,
      resourcePath: resourcePath,
      jwtToken: jwtToken,
      params: params,
      // TODO: Review for removal (PII) before live
      "function": 'wcGet',
      module: 'wc-api',
      jsError: ex,
      message: 'WC SDK wcGet failed'
    });
  }
  return null;
};

/**
 * Builds the url
 * @param {*} wcEnv  - if empty uses default.
 * @param String resourcePath
 */
var getUrlFacade = function getUrlFacade(wcEnv, resourcePath) {
  return "".concat(wcEnv.protocol || getProtocol(), "://").concat(wcEnv.host || getHost()).concat(wcEnv.prefix || getPrefix()).concat(wcEnv.rootUri || getRootUri()).concat(resourcePath);
};

/**
 * POST for WC API calls
 * Note: brand will get added as part of request body
 * @param {*} wcEnv
 * @param String resourcePath
 * @param {*} jwtToken
 * @param {*} data
 */
var wcPost = function wcPost(wcEnv, resourcePath, jwtToken, data) {
  var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  try {
    mbpLogger.logDebug({
      data: data,
      "function": 'wcPost',
      module: 'wc-api',
      message: 'wcPost: data'
    });
    var url = getUrlFacade(wcEnv, resourcePath);
    return callAxios('post', url, params, data, wcEnv, jwtToken);
  } catch (ex) {
    mbpLogger.logError({
      wcEnv: wcEnv,
      resourcePath: resourcePath,
      jwtToken: jwtToken,
      data: data,
      // TODO: Review for removal (PII) before live
      "function": 'wcPost',
      module: 'wc-api',
      jsError: ex,
      message: 'WC SDK wcPost failed'
    });
  }
  return null;
};

/**
 * POST for WC API calls without needing a jwt header...
 * Note: brand will get added as part of request body
 * @param {*} wcEnv
 * @param String resourcePath
 * @param {*} jwtToken
 * @param {*} data
 */
var wcPostWithCredentials = function wcPostWithCredentials(wcEnv, resourcePath, data, params, headersInput) {
  var method = 'post';
  try {
    mbpLogger.logDebug({
      data: data,
      "function": 'wcPost',
      module: 'wc-api',
      message: 'wcPost: data'
    });
    var url = getUrlFacade(wcEnv, resourcePath);
    var headers = _objectSpread$1(_objectSpread$1({}, headersInput), {}, {
      'baggage-sessionid': getShopperManagerCookie()
    });
    var appVersion = getVersion();
    if (appVersion) {
      headers['app-version'] = appVersion;
    }
    var config = {
      method: method,
      url: url,
      params: _objectSpread$1({}, params),
      headers: _objectSpread$1({}, headers),
      data: data,
      withCredentials: true
    };
    return axios(config);
  } catch (ex) {
    mbpLogger.logError({
      wcEnv: wcEnv,
      resourcePath: resourcePath,
      data: data,
      // TODO: Review for removal (PII) before live
      "function": 'wcPost',
      module: 'wc-api',
      jsError: ex,
      message: 'WC SDK wcPost failed'
    });
  }
  return null;
};

/*  FIXME: eliminate facade version, should only be one.
************************ FACADE VERSION ************************
*/

/**
 * Get for facade layer
 * Note: brand will get added as parameter on the URL and not part of request body
 * @param {*} wcEnv
 * @param {*} resourcePath
 * @param {*} jwtToken
 * @param {*} params
 */
var wcGetFacade = function wcGetFacade(wcEnv, resourcePath, jwtToken, params) {
  return callAxios('get', getUrlFacade(wcEnv, resourcePath), params, null, wcEnv, jwtToken, null);
};

/**
 * POST for facade layer
 * Note: brand will get added as part of request body
 * @param {*} wcEnv
 * @param String resourcePath
 * @param {*} jwtToken
 * @param {*} data
 */
var wcPostFacade = function wcPostFacade(wcEnv, resourcePath, jwtToken, data) {
  var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  return callAxios('post', getUrlFacade(wcEnv, resourcePath), params, data, wcEnv, jwtToken, null);
};

/**
 * PUT for facade layer
 * Note: brand will get added as part of request body
 * @param {*} wcEnv
 * @param String resourcePath
 * @param {*} jwtToken
 * @param {*} data
 */
var wcPutFacade = function wcPutFacade(wcEnv, resourcePath, jwtToken, data) {
  var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  return callAxios('put', getUrlFacade(wcEnv, resourcePath), params, data, wcEnv, jwtToken, null);
};

/**
 * PATCH for facade layer
 * Note: brand will get added as part of request body
 * @param {*} wcEnv
 * @param String resourcePath
 * @param {*} jwtToken
 * @param {*} data
 */
var wcPatchFacade = function wcPatchFacade(wcEnv, resourcePath, jwtToken, data) {
  var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  return callAxios('patch', getUrlFacade(wcEnv, resourcePath), params, data, wcEnv, jwtToken, null);
};

/**
 * DELETE for facade layer
 * Note: brand will get added as parameter on the URL and not part of request body
 * @param {*} wcEnv
 * @param {*} resourcePath
 * @param {*} jwtToken
 * @param {*} data
 */
var wcDeleteFacade = function wcDeleteFacade(wcEnv, resourcePath, jwtToken, data, params) {
  return callAxios('delete', getUrlFacade(wcEnv, resourcePath), params, data, wcEnv, jwtToken, null);
};

/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

var WcClient = {
  wcGet: wcGet,
  wcPost: wcPost,
  wcGetFacade: wcGetFacade,
  wcPostFacade: wcPostFacade,
  wcPutFacade: wcPutFacade,
  wcPatchFacade: wcPatchFacade,
  wcDeleteFacade: wcDeleteFacade,
  wcPostWithCredentials: wcPostWithCredentials
};

/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

var RESOURCE_PAGE$7 = "person";
var registerNewUser = function registerNewUser(wcEnv, values) {
  return WcClient.wcPost(wcEnv, RESOURCE_PAGE$7, values,
  // data
  {
    // config
    withCredentials: true,
    credentials: 'same-origin'
  }).then(function (response) {
    return response;
  });
};

/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

var RESOURCE_PAGE$6 = "person/@self";
var getUserData = function getUserData(wcEnv, params) {
  return WcClient.wcGet(wcEnv, RESOURCE_PAGE$6, {
    params: params,
    withCredentials: true,
    credentials: 'same-origin'
  }).then(function (response) {
    return response;
  });
};

/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

var isRegisteredUser = function isRegisteredUser(wcEnv) {
  // call service
  return getUserData(wcEnv, {
    // nothing to send
    test: 'test'
  }).then(function (response) {
    mbpLogger.logDebug({
      wcEnv: wcEnv,
      response: response,
      "function": 'getUserData',
      module: 'wc-api-person',
      message: 'isRegisteredUser | Response data'
    });
    if (response && response.data.registrationStatus == 'RegisteredPerson') {
      return true;
    } else {
      return false;
    }
  })["catch"](function (error) {
    mbpLogger.logError({
      wcEnv: wcEnv,
      "function": 'getUserData',
      module: 'wc-api-person',
      jsError: error,
      message: 'isRegisteredUser | Get User Data error'
    });
    return false;
  });
};

/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

var RESOURCE_PAGE$5 = "loginidentity";
var getUserIdentity = function getUserIdentity(wcEnv, values) {
  return WcClient.wcPost(wcEnv, RESOURCE_PAGE$5, values,
  // data
  {
    // config
    withCredentials: true,
    credentials: 'same-origin'
  }).then(function (response) {
    return response;
  });
};

/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/**
 * Get user session tokens
 * - if no logonId provided then returns guest tokens
 * - gets these to tokens from wcs WCToken and WCTrustedToken
 * @param {*} wcEnv 
 * @param {*} logonId 
 * @param {*} logonPassword 
 */
var getUserSession = function getUserSession(wcEnv, logonId, logonPassword) {
  var RESOURCE_PAGE_FACADE;
  var values;
  if (logonId && logonPassword) {
    RESOURCE_PAGE_FACADE = "/logonidentity";
    values = {
      logonId: logonId,
      logonPassword: logonPassword
    };
  } else {
    RESOURCE_PAGE_FACADE = "/guestidentity";
  }
  wcEnv.rootUri = "/session/";

  // http://localhost:8080/session/harryanddavid/guestidentity

  return WcClient.wcPostFacade(wcEnv, RESOURCE_PAGE_FACADE, values,
  // data
  {// config
    //withCredentials: true,
    //credentials: 'same-origin'
  }).then(function (response) {
    return response;
  });
};

/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

var RESOURCE_PAGE$4 = "guesttoken";
var getGuestToken = function getGuestToken(wcEnv, data) {
  if (!wcEnv) {
    wcEnv = {
      rootUri: "/session/"
    };
  }
  if (!wcEnv.rootUri) {
    wcEnv.rootUri = "/session/";
  }
  return WcClient.wcPost(wcEnv, RESOURCE_PAGE$4, null, data).then(function (response) {
    return response;
  });
};

/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

var RESOURCE_PAGE$3 = "migrateGuestToRegisteredUser";
var migrateGuestToRegisteredUser = function migrateGuestToRegisteredUser(wcEnv, jwtRegistered, jwtGuest) {
  if (!wcEnv) {
    wcEnv = {
      rootUri: "/session/"
    };
  }
  if (!wcEnv.rootUri) {
    wcEnv.rootUri = "/session/";
  }
  return WcClient.wcPutFacade(wcEnv, RESOURCE_PAGE$3, jwtRegistered, {
    accessToken: jwtGuest
  }).then(function (response) {
    return response;
  });
};

/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

var CONTEXT$5 = "addressbook/contacts";
var getAddressBook = function getAddressBook(env, contactId, pageNumber, jwt) {
  var resourcePath = "".concat(CONTEXT$5, "/").concat(contactId, "/entries");
  var params = {
    pageNumber: pageNumber,
    IncludeAddresses: 'true'
  };
  return memberClient.performGet(env, resourcePath, jwt, params).then(function (response) {
    return response;
  });
};

/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

var CONTEXT$4 = "addressbook/contacts";
var registerNewAddressBook = function registerNewAddressBook(env, jwt, contactId, bookAddressEntry) {
  var addressEntry = bookAddressEntry.addressEntry,
    address = bookAddressEntry.address;
  var resourcePath = "".concat(CONTEXT$4, "/").concat(contactId, "/entryandaddress");
  var params = {
    addressEntry: addressEntry,
    address: address
  };
  return memberClient.performPost(env, resourcePath, jwt, params).then(function (response) {
    return response;
  });
};

/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

var CONTEXT$3 = "addressbook/contacts";
var editAddressBook = function editAddressBook(env, jwt, contactId, bookAddressEntry) {
  var addressEntry = bookAddressEntry.addressEntry,
    address = bookAddressEntry.address;
  var resourcePath = "".concat(CONTEXT$3, "/").concat(contactId, "/entries/").concat(bookAddressEntry.addressEntry.AddressBookEntryId, "/address");
  var params = {
    addressEntry: addressEntry,
    address: address
  };
  return memberClient.performPut(env, resourcePath, jwt, params).then(function (response) {
    return response;
  });
};

/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

var CONTEXT$2 = "addressbook/contacts";
var removeAddressBook = function removeAddressBook(env, contactId, addressBookEntryId, jwt) {
  var resourcePath = "".concat(CONTEXT$2, "/").concat(contactId, "/entries/").concat(addressBookEntryId);
  var params = {};
  return memberClient.performDelete(env, resourcePath, jwt, params).then(function (response) {
    return response;
  });
};

/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

var CONTEXT$1 = "wallets";
var getWallet = function getWallet(env, contactId, jwt) {
  var resourcePath = "".concat(CONTEXT$1, "/").concat(contactId, "/cards");
  return memberClient.performGet(env, resourcePath, jwt, null).then(function (response) {
    return response;
  });
};

/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

var RESOURCE_PAGE$2 = "loginByUserName";
var clearCommerceCookies = function clearCommerceCookies() {
  var cookies = new Cookies();
  var options = {
    path: '/'
  };
  var allCookies = cookies.getAll(options);
  Object.keys(allCookies).forEach(function (key) {
    if (key.startsWith('WC_AUTHENTICATION') || key.startsWith('WC_USERACTIVITY')) {
      cookies.remove(key, options);
    }
  });
};
var loginByUserName = function loginByUserName(wcEnv, data, params, clearWcCookies) {
  if (!wcEnv) {
    wcEnv = {
      rootUri: "/session/"
    };
  }
  if (!wcEnv.rootUri) {
    wcEnv.rootUri = "/session/";
  }
  var headers = {
    'Content-Type': 'application/json'
  };
  if (clearWcCookies) {
    clearCommerceCookies();
  }
  return WcClient.wcPostWithCredentials(wcEnv, RESOURCE_PAGE$2, data, params, headers);
};

/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

var RESOURCE_PAGE$1 = "logoff";
var logoffUser = function logoffUser(wcEnv, jwtToken) {
  if (!wcEnv) {
    wcEnv = {
      rootUri: "/session/"
    };
  }
  if (!wcEnv.rootUri) {
    wcEnv.rootUri = "/session/";
  }
  return WcClient.wcDeleteFacade(wcEnv, RESOURCE_PAGE$1, jwtToken).then(function (response) {
    return response;
  });
};
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var RESOURCE_PAGE = "RemoveCookies";
var HOST_NAME = typeof window !== 'undefined' ? window.location.hostname : '';
var ROOT_URI = 'webapp/wcs/stores/servlet/';

//Fixme : move axios call to wc api
var removeCommerceCookies = function removeCommerceCookies(params) {
  var url = 'https://' + HOST_NAME + '/' + ROOT_URI + RESOURCE_PAGE;
  var method = 'get';
  var cookies = new Cookies();
  var headers = {
    'Content-Type': 'text/plain',
    sessionId: cookies.get('ShopperManagerEnterprise') || 'NO_ShopperManagerEnterprise_COOKIE'
  };
  var data = {};
  var config = {
    method: method,
    url: url,
    params: _objectSpread({}, params),
    headers: _objectSpread({}, headers),
    data: data,
    withCredentials: true
  };
  return axios(config);
};

/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

var CONTEXT = "addressbook/composite/billingwallet";
var getBillingAddress = function getBillingAddress(env, contactId, jwt) {
  var resourcePath = "".concat(CONTEXT, "/").concat(contactId);
  var params = {
    billingonly: "true"
  };
  return memberClient.performGet(env, resourcePath, jwt, params).then(function (response) {
    return response;
  });
};

/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

var RESOURCE_PAGE_FACADE$1 = "/cart";
var RESOURCE_ROOT_FACADE$2 = "checkout";
var RESOURCE_PAGE_ACTION$1 = "/shoprunner/validate";
var validateShopRunner = function validateShopRunner(wcEnv, jwtToken, srToken, brand) {
  // wcEnv.rootUri = RESOURCE_ROOT_FACADE;

  var resourcePage = RESOURCE_ROOT_FACADE$2 + RESOURCE_PAGE_FACADE$1 + RESOURCE_PAGE_ACTION$1 + "?srtoken=" + srToken + "&brand=" + brand;
  return memberClient.performGet(wcEnv, resourcePage, jwtToken, null).then(function (response) {
    return response;
  });
};

/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

var RESOURCE_PAGE_FACADE = "/signup";
var RESOURCE_ROOT_FACADE$1 = "/profile/auth0";

// Creating account after place order in confirmation page. 
// mbp-pwa-ui/src/state/ducks/Checkout/ducks/Payment/ducks/Account/Account-Operations.js
var createAccountSignUp = function createAccountSignUp(wcEnv, jwtToken, optInEntry) {
  wcEnv.rootUri = RESOURCE_ROOT_FACADE$1;
  var resourcePage = RESOURCE_PAGE_FACADE;
  return WcClient.wcPostFacade(wcEnv, resourcePage, jwtToken, optInEntry).then(function (response) {
    return response;
  });
};

/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

var RESOURCE_PATH = "cryptoservice/tokenize";
var tokenizeCard = function tokenizeCard(env, jwt, cardNumber, sourceID) {
  var resourcePath = RESOURCE_PATH;
  var payload = {
    ccNumber: cardNumber,
    sourceID: sourceID
  };
  return memberClient.performPost(env, resourcePath, jwt, payload).then(function (response) {
    return response;
  });
};

/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

var RESOURCE_ROOT_FACADE = "/wallets/";
var RESOURCE_PAGE_ACTION = "/cards";
var addCardToWallet = function addCardToWallet(wcEnv, jwtToken, contactId, payloadData) {
  var accountNumber = payloadData.accountNumber,
    nameOnCreditCard = payloadData.nameOnCreditCard;
  payloadData.expirationMonth;
  payloadData.expirationYear;
  var cardType = payloadData.cardType,
    firstTwoDigits = payloadData.firstTwoDigits,
    lastFourDigits = payloadData.lastFourDigits,
    expiryDate = payloadData.expiryDate,
    sourceID = payloadData.sourceID;
  var payload = {
    wallet: {
      cardType: cardType,
      payType: "CC",
      cardHolderName: nameOnCreditCard,
      cardNumber: accountNumber,
      firstTwoDigits: firstTwoDigits,
      lastFourDigits: lastFourDigits,
      expiryDate: expiryDate,
      status: "A",
      subsIndicator: 0,
      cryptoFlag: "AES",
      tokenFlag: 0,
      sourceID: sourceID
    }
  };
  var resourcePath = "".concat(RESOURCE_ROOT_FACADE).concat(contactId).concat(RESOURCE_PAGE_ACTION);
  return memberClient.performPost(wcEnv, resourcePath, jwtToken, payload).then(function (response) {
    return response;
  });
};

/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

var PersonClient = {
  registerNewUser: registerNewUser,
  getUserData: getUserData,
  isRegisteredUser: isRegisteredUser,
  getUserIdentity: getUserIdentity,
  getUserSession: getUserSession,
  getGuestToken: getGuestToken,
  migrateGuestToRegisteredUser: migrateGuestToRegisteredUser,
  getAddressBook: getAddressBook,
  registerNewAddressBook: registerNewAddressBook,
  editAddressBook: editAddressBook,
  removeAddressBook: removeAddressBook,
  getBillingAddress: getBillingAddress,
  getWallet: getWallet,
  loginByUserName: loginByUserName,
  logoffUser: logoffUser,
  removeCommerceCookies: removeCommerceCookies,
  validateShopRunner: validateShopRunner,
  createAccountSignUp: createAccountSignUp,
  tokenizeCard: tokenizeCard,
  addCardToWallet: addCardToWallet
};
export { PersonClient as default };